import Vue from "vue";
import VueRouter from "vue-router";
import store from '../store';

Vue.use(VueRouter);

const routes = [
  {
    name: "Home",
    path: "/",
    component: () =>
      import(/* webpackChunkName: "Home" */ "../components/Home.vue")
  },
  {
    name: "AdminBooksCreate",
    path: "/admin/books/create",
    component: () =>
      import(
        /* webpackChunkName: "AdminBooksCreate" */ "../components/admin/AdminBooksCreate.vue"
      )
  },
  {
    name: "AdminNotes",
    path: "/admin/notes",
    component: () =>
      import(
        /* webpackChunkName: "AdminNotes" */ "../components/admin/AdminNotes.vue"
      )
  },
  {
    name: "AdminBooksBookUpdate",
    path: "/admin/books/:book/update",
    component: () =>
      import(
        /* webpackChunkName: "AdminBooksBookUpdate" */ "../components/admin/AdminBooksBookUpdate.vue"
      )
  },
  {
    name: "AdminNotesNoteUpdate",
    path: "/admin/notes/:note/update",
    component: () =>
      import(
        /* webpackChunkName: "AdminNotesNoteUpdate" */ "../components/admin/AdminNotesNoteUpdate.vue"
      )
  },
  {
    name: "AdminNotesCreate",
    path: "/admin/notes/create",
    component: () =>
      import(
        /* webpackChunkName: "AdminNotesCreate" */ "../components/admin/AdminNotesNoteUpdate.vue"
      )
  },
  {
    name: "AdminSettings",
    path: "/admin/settings",
    component: () =>
      import(
        /* webpackChunkName: "AdminSettings" */ "../components/admin/AdminSettings.vue"
      )
  },
  {
    name: "Discover",
    path: "/notes",
    component: () =>
      import(/* webpackChunkName: "Discover" */ "../components/NotesSearch.vue")
  },
  {
    name: "NotesBook",
    path: "/book/:book",
    component: () =>
        import(/* webpackChunkName: "NotesSearch" */ "../components/NotesSearch.vue")
  },
  {
    name: "NotesSearch",
    path: "/notes/search",
    component: () =>
      import(
        /* webpackChunkName: "NotesSearch" */ "../components/NotesSearch.vue"
      )
  },
  {
    name: "NotesFavs",
    path: "/notes/favs",
    component: () =>
      import(
        /* webpackChunkName: "NotesFavs" */ "../components/NotesSearch.vue"
      )
  },
  {
    name: "UserHome",
    path: "/u/:user",
    component: () =>
      import(/* webpackChunkName: "UserHome" */ "../components/UserHome.vue")
  },
  {
    name: "UserBook",
    path: "/u/:user/:book",
    component: () =>
      import(/* webpackChunkName: "UserBook" */ "../components/UserBook.vue")
  },
  {
    name: "UserNote",
    path: "/u/:user/:book/:note",
    component: () =>
      import(/* webpackChunkName: "UserNote" */ "../components/UserNote.vue")
  },
  {
    name: "Login",
    path: "/login",
    component: () =>
      import(/* webpackChunkName: "Login" */ "../components/Login.vue")
  },
  {
    name: "Register",
    path: "/Register",
    component: () =>
      import(/* webpackChunkName: "Register" */ "../components/Register.vue")
  },
  {
    name: "ForgotPassword",
    path: "/forgot-password",
    component: () =>
      import(
        /* webpackChunkName: "ForgotPassword" */ "../components/ForgotPassword.vue"
      )
  },
  {
    name: "ForgotPasswordReset",
    path: "/forgot-password-reset",
    component: () =>
      import(
        /* webpackChunkName: "ForgotPasswordReset" */ "../components/ForgotPasswordReset.vue"
      )
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

//guard clause
router.beforeEach((to, from, next) => {
  console.log('navigating', store.state.notes.route, to.fullPath, from.fullPath);
  if (to.fullPath !== from.fullPath) {
    store.commit('mSetRoute', to.fullPath);
  }
  next();

  // if (to.matched.some(record => record.meta.requiresLogin) && store.state.user.authenticated == false) {
  //   store.commit("setGlobalError", "You need to log in before you can perform this action.")
  //   next("/Login")
  // } else {
  //   next()
  // }
})

export default router;
